import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { computed, observable, toJS } from 'mobx';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import get from 'lodash/get';
import Commentaries from './Commentaries';
import { DataStore, EntityStore } from '../stores';
import { ReadMoreLessOptions } from '../models/configuration/components/ReadMoreLessOptions';
import HTag from './HTag';
import { utils } from '@kurtosys/ksys-app-template';
import { CommentaryContent } from '../models/entity';
import { Theme } from '../models/Theme';

const FundCommentaryWrapper = styled<any, any>(
    'article',
    'fundCommentaryWrapper',
    'fundCommentary'
)`
    ${propStyles};
`;

FundCommentaryWrapper.defaultProps = {};

interface TCommentariesDictionary {
    [property: string]: string;
}

interface TCommentariesType {
    commentaryType: string;
}

interface TFundCommentary {
    label: string;
    commentaries: Array<TCommentariesType>;
    showReadMoreLess?: boolean;
    readMoreLessOptions?: ReadMoreLessOptions;
}

interface FundCommentaryProps {
    theme?: Theme;
    dataStore?: DataStore;
    entityStore?: EntityStore;
    showHeading: boolean;
    fundCommentary: TFundCommentary;
    commentaries?: Array<string>;
}

@inject('dataStore', 'entityStore')
@observer
class FundCommentary extends Component<FundCommentaryProps> {
    @computed
    get commentariesDictionary(): TCommentariesDictionary {
        const { dataStore, entityStore } = this.props;
        const commentariesDictionary = {};
        const { commentaries = {} } = entityStore.value;

        for (const c in commentaries) {
            if (c && commentaries[c]) {
                const { commentary = '' } = (commentaries[c].find(
                    cc => cc.culture === dataStore.culture
                ) ||
                    commentaries[c].find(
                        cc => cc.culture === dataStore.config.defaultCulture
                    ) ||
                    {}) as CommentaryContent;
                commentariesDictionary[c] = commentary;
            }
        }

        return commentariesDictionary;
    }

    @computed
    get orchestratedReadMoreLessOptions(): ReadMoreLessOptions {
        const { fundCommentary } = this.props;
        const orchestratedReadMoreLessOptions = toJS(
            fundCommentary.readMoreLessOptions
        );
        if (
            orchestratedReadMoreLessOptions &&
            !utils.typeChecks.isNullOrEmpty(
                orchestratedReadMoreLessOptions.readMoreCommentaries
            )
        ) {
            orchestratedReadMoreLessOptions.readMoreCommentaries = orchestratedReadMoreLessOptions.readMoreCommentaries
                .map(c => get(this.commentariesDictionary, c.commentaryType))
                .filter(c => !utils.typeChecks.isNullOrUndefined(c));
            return observable(orchestratedReadMoreLessOptions);
        }
        return fundCommentary.readMoreLessOptions;
    }

    @computed
    get commentaries(): Array<string> {
        return this.getCommentaries(this.props.fundCommentary.commentaries);
    }

    getCommentaries = (
        commentaryTypes: Array<TCommentariesType> = []
    ): Array<string> => {
        const commentaries = commentaryTypes
            .map(d => get(this.commentariesDictionary, d.commentaryType))
            .filter(d => d !== undefined);
        return commentaries;
    };

    render() {
        const { theme, showHeading, fundCommentary } = this.props;
        const { commentaries } = this;

        if (utils.typeChecks.isNullOrEmpty(commentaries)) {
            return null;
        }

        return (
            <FundCommentaryWrapper {...theme.FundCommentaryWrapper}>
                {showHeading && (
                    <HTag
                        componentTheme={'FundCommentaryHeading'}
                        defaultStyleProps={{
                            color: 'body',
                            fontFamily: 'heading',
                            fontWeight: 'bold',
                            fontSize: 'md',
                        }}
                        level={2}
                        text={fundCommentary.label}
                    />
                )}
                <Commentaries
                    commentaries={commentaries}
                    showReadMoreLess={fundCommentary.showReadMoreLess}
                    readMoreLessOptions={this.orchestratedReadMoreLessOptions}
                    {...theme.FundCommentaryContent}
                />
            </FundCommentaryWrapper>
        );
    }
}

export default withTheme(FundCommentary);



// WEBPACK FOOTER //
// ./src/Components/FundCommentary.tsx